<script>
import { Line, Bar } from "vue-chartjs";
export default {
  extends: Bar,
  props: ["chartdata", "options"],
  mounted() {
    this.drawChart();
  },
  computed: {
    chartData: function() {
      return this.chartdata;
    }
  },
  methods: {
    drawChart: function() {
      this.renderChart(this.chartdata, this.options);
    }
  },
  watch: {
    chartData: function() {
      this.drawChart();
    }
  }
};
</script>